import { DatePipe } from "@angular/common";

export function toCamelCase(value: string): string {
  return value.charAt(0).toLocaleLowerCase() + value.slice(1);
}

export function toPascalCase(value: string): string {
  if (!value) return;

  return value
    .toLowerCase()
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}

let invalidCharacters = /["]/g;
export function clearString(value: string): string {
  if (!value) return null;
  return toPascalCase(value.trim().replace(invalidCharacters, ""));
}

export function capitalizeFirstLetter(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
export function capitalize(value: string) {
  return value?.toUpperCase();
}
export function getFormattedDate() {
  const datepipe: DatePipe = new DatePipe("en-US");
  return datepipe.transform(new Date(), "YYYY-MM-dd_HHmmss");
}
export function extractCai(value: string) {
  if (!value) return value;

  let userName = value.trim().toUpperCase();
  if (userName.length == 4) return userName;
  if (userName.startsWith("CT")) return userName.substring(3);
  let startIndex = userName.lastIndexOf("(") + 1,
    endIndex = startIndex + 4;

  if (startIndex < 1 || endIndex > userName.length) return null;
  return userName.substring(startIndex, endIndex);
}
export function trimChar(s, c) {
  if (c === "]") c = "\\]";
  if (c === "^") c = "\\^";
  if (c === "\\") c = "\\\\";
  return s.replace(new RegExp("^[" + c + "]+|[" + c + "]+$", "g"), "");
}
